import * as React from "react";
import { useEffect, useState } from "react";
import * as screenfull from "screenfull";
import { resize$ } from "../../events/eventsBrowser";
import { HudOptionButton } from "../generic/hud-option-button/HudOptionButton";
import { IdIcon } from "../generic/icon/IdIcon";
export var HudToggleFullscreen = function () {
    if (!screenfull) {
        return React.createElement(React.Fragment, null);
    }
    var _a = useState(screenfull.isFullscreen), isFullscreen = _a[0], setFullscreen = _a[1];
    useEffect(function () {
        return resize$.subscribe(function () {
            setFullscreen(screenfull && screenfull.enabled && screenfull.isFullscreen);
        }).unsubscribe;
    }, []);
    var onClick = function () {
        if (screenfull && screenfull.enabled) {
            if (!isFullscreen) {
                screenfull.request();
            }
            else {
                screenfull.exit();
            }
        }
    };
    var icon = isFullscreen ? IdIcon.OptionsFullscreenCloseIcn : IdIcon.OptionsFullscreenIcn;
    return React.createElement(HudOptionButton, { icon: icon, onClick: onClick });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fullscreen/HudToggleFullscreen.tsx
// module id = 2316
// module chunks = 3